<template>
  <Layout>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6">
            <div class="card card-warning card-outline shadow">
              <div class="card-header text-primary font-weight-bold">
                <span style="color: Tomato;">
                  <i class="fas fa-rss"></i>
                </span> แนะนำและอัพเดทข่าวสาร
              </div>
              <div class="card-body">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe
                    class="embed-responsive-item"
                    src="https://www.youtube.com/embed/lhfsRZpQ0Jg"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-md-6 -->
          <div class="col-lg-6">
            <div class="card card-warning card-outline shadow mb-4">
              <a href="#ID_TBL" class="d-block card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  <i class="far fa-user"></i>
                  บัญชีของฉัน
                </h6>
              </a>

              <div class="row">
                <div class="col-lg-6">
                  <form action method="POST">
                    <div class="form-row mx-3 my-3">
                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1">MT4/MT5 ID</label>
                        <input
                          type="text"
                          class="form-control"
                          id="ID_Trade"
                          name="ID_Trade"
                          pattern="[0-9]{1,}"
                          placeholder="Enter ID number"
                          required
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1">Broker</label>
                        <select class="form-control" id=" Broker" name="Broker" required>
                          <option value selected disabled hidden>Broker</option>
                          <option value="BR0001">Axi Trader</option>
                          <option value="BR0002">Global XM</option>
                        </select>
                      </div>

                      <div class="md-form col-md-12">
                        <button type="submit" class="btn btn-primary col-md-12">เพิ่มบัญชีเทรด</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <div class="continer mx-1 my-1">
                    <a href="https://www.vultr.com/?ref=8019953" target="_blank">
                      <img
                        src="http://www.fxhanuman.com/web/eafx/1/Pictrue/New%20folder/banner_1200x628_v2.png"
                        class="img-fluid height: auto;"
                        alt="Responsive image"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- /.col-md-6 -->
          <div class="col-lg-6">
            <div class="card shadow">
              <div class="card-header">
                <h6 class="m-0 font-weight-bold text-primary">โบรคเกอร์ที่แนะนำ</h6>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Broker</th>
                      <th>Contact</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a href="#">
                          <img src="../../public/img/broker-logo/BR0001.png" />
                        </a>
                      </td>
                      <td>
                        <a
                          target="_blank"
                          href="https://www.fxhanuman.com/web/index.php/2015-06-06-07-40-52/axitrader-review"
                        >AxiTrader</a>
                        <br />
                        <a target="_blank" href="https://youtu.be/9Ued7kL9WAk">youtube</a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#">
                          <img src="../../public/img/broker-logo/BR0002.png" />
                        </a>
                      </td>
                      <td>
                        <a
                          target="_blank"
                          href="https://fxhanuman.com/web/index.php/2015-06-06-07-40-52/xm"
                        >Global XM</a>
                        <br />
                        <a target="_blank" href="https://youtu.be/nQiOsgFm4TM">youtube</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- /.col-md-6 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";

export default {
  name: "home",
  components: {
    Layout
  }
};
</script>
